module.exports = __webpack_public_path__ + "static/media/return.dd1175f4.png";